'use client';

import { Link } from '@/i18n/navigation';
import { Stagger, StaggerChild } from '@/components/motion/InView';
import { CalendarCheck, Clock, MapPin, Phone } from 'lucide-react';
import {
  localized,
  type QuickInfoBlockConfig,
  type RestaurantLocale,
} from '@restaurant/config';
import styles from './QuickInfoSection.module.css';

const icons = {
  clock: Clock,
  'map-pin': MapPin,
  phone: Phone,
  calendar: CalendarCheck,
} as const;

interface QuickInfoSectionProps {
  blocks: QuickInfoBlockConfig[];
  locale: RestaurantLocale;
}

export function QuickInfoSection({ blocks, locale }: QuickInfoSectionProps) {
  return (
    <section className={styles.section}>
      <Stagger className={styles.container} stagger={0.1} delayChildren={0.05}>
        {blocks.filter((block) => block.isActive).map((block) => {
          const Icon = icons[block.icon];
          const isInternal = block.actionHref.startsWith('/');
          return (
          <StaggerChild key={block.key}>
            <article className={styles.card}>
              <Icon className={styles.icon} aria-hidden="true" />
              <h3 className={styles.cardTitle}>{localized(block.title, locale)}</h3>
              <p className={styles.cardLead}>{localized(block.line1, locale)}</p>
              <p className={styles.cardText}>{localized(block.line2, locale)}</p>
              {isInternal ? (
                <Link href={block.actionHref as any} className={styles.cardAction}>
                  {localized(block.actionLabel, locale)}
                </Link>
              ) : (
                <a className={styles.cardAction} href={block.actionHref}>
                  {localized(block.actionLabel, locale)}
                </a>
              )}
            </article>
          </StaggerChild>
        )})}
      </Stagger>
    </section>
  );
}
